export default "__VITE_ASSET__DAXJJ4oO__"